import { useEffect } from 'react';
import { useTabAlertStore } from './tab-alert-store.js';

/**
 * Базовое имя приложения. Используется как суффикс в `<title>` для всех
 * страниц, чтобы пользователь видел контекст и в истории браузера, и в
 * pull-to-switch на iOS Safari.
 */
export const APP_NAME = 'Claude Remote';

const MAX_TITLE_LEN = 70;

function truncate(s: string, max = MAX_TITLE_LEN): string {
  const clean = s.replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  return clean.slice(0, max - 1).trimEnd() + '…';
}

/**
 * Собирает meta title по шаблону `<part1> — <part2> — … — Claude Remote`.
 * Пустые/`null`/`undefined` куски пропускаются. Каждая часть обрезается,
 * чтобы суммарный заголовок не разрастался.
 */
export function buildTitle(...parts: Array<string | null | undefined>): string {
  const filtered = parts
    .map((p) => (p == null ? '' : String(p).trim()))
    .filter((p) => p.length > 0)
    .map((p) => truncate(p));
  if (filtered.length === 0) return APP_NAME;
  return `${filtered.join(' — ')} — ${APP_NAME}`;
}

/**
 * Хук: сохраняет базовый title в store. Финальный document.title
 * формируется в useTabAlert с учётом счётчика алертов.
 *
 * Вызывать с уже готовой строкой (используй `buildTitle(...)`).
 */
export function useDocumentTitle(title: string): void {
  const setBaseTitle = useTabAlertStore((s) => s.setBaseTitle);

  useEffect(() => {
    if (title) {
      setBaseTitle(title);
    }
  }, [title, setBaseTitle]);
}
